import { gql } from "@apollo/client";

export const GET_CONTACT = gql`
  query contact($id: ID!) {
    contact(id: $id) {
      id
      address {
        addressName
        address1
        address2
        zipcode
        state
        city
        country
      }
      businessName
      contactType
      createdAt
      department {
        id
      }
      email
      firstName
      lastName
      notes
      parentContactId
      phone
      relationshipType
      searchTerm
      status
      submittedBy {
        id
        firstName
        lastName
      }
      paymentBankInfo
      title
      updatedAt
      website
      customFields {
        fieldSettingId
        values
      }
    }
  }
`;

export const GET_CONTACTS = gql`
  query contacts(
    $firstName: String
    $lastName: String
    $email: String
    $phone: String
    $contactType: ContactTypeEnum
    $status: [ContactStatusEnum]
    $verificationStatus: [ContactVerificationStatusEnum]
    $searchTerm: String
    $first: Int
    $after: String
  ) {
    contacts(
      firstName: $firstName
      lastName: $lastName
      email: $email
      phone: $phone
      contactType: $contactType
      status: $status
      verificationStatus: $verificationStatus
      searchTerm: $searchTerm
      first: $first
      after: $after
    ) {
      edges {
        node {
          id
          address {
            addressName
            address1
            address2
            zipcode
            state
            city
            country
          }
          businessName
          contactType
          createdAt
          department {
            id
          }
          email
          firstName
          lastName
          notes
          parentContactId
          phone
          relationshipType
          searchTerm
          status
          verificationStatus
          submittedBy {
            id
            firstName
            lastName
          }
          paymentBankInfo
          title
          updatedAt
          website
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

/** Names only, for a filter list: GET_CONTACTS also pulls the address and bank info of every row. */
export const GET_CONTACT_FILTER_OPTIONS = gql`
  query contactFilterOptions($first: Int, $status: [ContactStatusEnum]) {
    contacts(first: $first, status: $status) {
      edges {
        node {
          id
          businessName
          firstName
          lastName
          email
          contactType
          parentContactId
        }
      }
    }
  }
`;

export const DOES_CONTACT_EXIST = gql`
  query doesContactExist($input: ContactExistenceInput!) {
    doesContactExist(input: $input) {
      id
      address {
        addressName
        address1
        address2
        zipcode
        state
        city
        country
      }
      businessName
      email
      firstName
      lastName
      parentContactId
      phone
      relationshipType
      status
      title
      website
    }
  }
`;

export const ADD_CONTACT = gql`
  mutation addContact($input: AddContactInput!) {
    addContact(input: $input) {
      id
      businessName
    }
  }
`;

export const UPDATE_CONTACT = gql`
  mutation updateContact($id: ID!, $input: UpdateContactInput!) {
    updateContact(id: $id, input: $input) {
      id
      address {
        addressName
        address1
        address2
        zipcode
        state
        city
        country
      }
      businessName
      contactType
      createdAt
      department {
        id
      }
      email
      firstName
      lastName
      notes
      parentContactId
      phone
      relationshipType
      searchTerm
      status
      submittedBy {
        id
        firstName
        lastName
      }
      updatedAt
      website
      customFields {
        fieldSettingId
        values
      }
    }
  }
`;

export const DELETE_CONTACT = gql`
  mutation deleteContact($id: ID!) {
    deleteContact(id: $id) {
      id
    }
  }
`;

export const REACTIVATE_CONTACT = gql`
  mutation reactivateContact($id: ID!) {
    reactivateContact(id: $id) {
      id
      contactType
    }
  }
`;

export const INVITE_CONTACT = gql`
  mutation inviteContact($id: ID!) {
    inviteContact(id: $id) {
      id
      email
      status
    }
  }
`;

export const GET_INDIVIDUALS_FOR_BUSINESS = gql`
  query individualsForBusiness($contactId: ID!, $status: ContactStatusEnum) {
    individualsForBusiness(contactId: $contactId, status: $status) {
      id
      firstName
      lastName
      email
      phone
      status
      title
      relationshipType
    }
  }
`;
